export default __webpack_public_path__ + "static/media/retroAtari.f4922888.ttf";